import {
  Row,
  Rate,
  Popconfirm,
  Button,
  Tooltip,
  Image,
  Modal,
  message,
} from "antd";
import { useEffect, useState } from "react";
import { useMobxStores } from "../../stores/stores";
import ReportModal from "./ReportModal";
import flagImage from "../../assets/Flag.png";
import deleteImage from "../../assets/Delete.png";

import { useParams, useNavigate } from "react-router-dom";
import { keycloak } from "../../utils/keycloak";
import ModelViewerPhone from "./ModelViewerPhone";
import { observer } from "mobx-react";
import { ReactComponent as TopRightShape } from "../../assets/ItemDetailsRight.svg";
import "./ItemDetailsPagePhone.css";

const ItemDetailsMedia = () => {
  const { marketplaceStore, ratingStore, userStore } = useMobxStores();
  const [isReportModalVisible, setIsReportModalVisible] = useState(false);

  // const initialRating =
  //   marketplaceStore.marketplaceItem?.item.overall_rating ?? 0;
  // const [rating, setRating] = useState(Math.round(initialRating));

  const initialRating =
    ratingStore.ratings.find(
      (rating) =>
        rating.item === marketplaceStore.marketplaceItem?.item.id &&
        rating.user === userStore.user?.id
    )?.rating ?? 0;

  const [rating, setRating] = useState(Math.round(initialRating));
  const [overallRating, setOverallRating] = useState(
    marketplaceStore.marketplaceItem?.item.overall_rating
  );
  const [viewers, setViewers] = useState(
    marketplaceStore.marketplaceItem?.item.num_of_ratings
  );

  const [showRatingModal, setShowRatingModal] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("hi3");
    console.log(marketplaceStore.marketplaceItem?.item.num_of_ratings);
    setOverallRating(marketplaceStore.marketplaceItem?.item.overall_rating);
    setViewers(marketplaceStore.marketplaceItem?.item.num_of_ratings);
  }, [marketplaceStore.marketplaceItem?.item.num_of_ratings]);

  const requireAuth = (onAuthenticated) => {
    if (keycloak.authenticated) {
      onAuthenticated();
    } else {
      Modal.confirm({
        title: "Sign in required",
        content:
          "You are not allowed to perform this action. You need to sign in first.",
        okText: "Sign in",
        cancelText: "Cancel",
        onOk: () =>
          keycloak.login({ redirectUri: window.location.href }),
      });
    }
  };

  const handleDeleteItem = (id) => {
    marketplaceStore.DeleteMarketplaceItemById(id);
    navigate("../marketplace");
  };

  const handleSubmitRating = async () => {
    const values = {
      user: userStore.user?.id,
      item: marketplaceStore.marketplaceItem?.item.id,
      rating: rating,
    };

    setShowRatingModal(false);

    const result = await ratingStore.PostRating(values);
    if (result.success) {
      message.success("Rating submitted successfully");
    } else {
      message.error("Rating could not be submitted");
    }

    // setRating(
    //   ratingStore.ratings.find(
    //     (rating) => rating.item === marketplaceStore.marketplaceItem?.item.id
    //   )?.rating ?? 0
    // );

    setRating(
      ratingStore.ratings.find(
        (rating) =>
          rating.item === marketplaceStore.marketplaceItem?.item.id &&
          rating.user === userStore.user?.id
      )?.rating ?? 0
    );
    console.log("hi1");
    ratingStore.GetRatings();
    marketplaceStore.GetMarketplaceItemById(params.pk);
  };

  return (
    <div style={{ position: "relative", marginTop: "12px" }}>
      {/* <TopRightShape
        style={{
          position: "absolute",
          zIndex: -1,
          marginTop: "-210px",
          marginLeft: "-200px",
          // top: "-140px",
          // right: "-16vw",
          width: "70vw", // scales with viewport width
          height: "700px", // keep aspect ratio
          pointerEvents: "none", // so it doesn’t block clicks
        }}
      /> */}
      {marketplaceStore.marketplaceItem?.item.type === "3D" ? (
        <ModelViewerPhone
          source_media={marketplaceStore.marketplaceItem?.item.source_media}
        />
      ) : (
        <Row style={{ width: "fit-content" }}>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "auto",
              backgroundColor: "black",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden", // just in case
              borderRadius: "20px",
            }}
            class="image-container"
          >
            <Image
              alt="item"
              src={
                marketplaceStore.marketplaceItem?.item.display_image
                  .medium_square_crop
              }
              preview={false}
              className="details-image-preview"
            />
          </div>
        </Row>
      )}
      <Row
        justify="space-between"
        style={{
          marginTop: "12px",
          width: "96vw",
          minWidth: "fit-content",
        }}
        // className="rowUnderImage"
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <Rate
            className="custom-rate"
            value={rating ?? initialRating}
            onChange={(value) =>
              requireAuth(() => {
                setRating(value);
                setShowRatingModal(true);
              })
            }
          />
          {overallRating && (
            <>
              <span
                className="next-to-rate"
                style={{
                  // fontSize: "34px",
                  letterSpacing: "2px",
                  fontWeight: "400",
                  color: "#8A8A8A",
                  lineHeight: 1,
                  margin: "0 6px 0 16px",
                }}
              >
                {overallRating}
              </span>
              <span
                className="in-brackets"
                style={{
                  fontSize: "24px",
                  fontWeight: "400",
                  color: "#8A8A8A",
                  letterSpacing: "2px",
                  paddingBottom: "4px",
                  lineHeight: 1,
                }}
              >
                ({viewers})
              </span>
            </>
          )}
        </div>
        <div style={{ display: "flex", gap: "16px" }}>
          {marketplaceStore.marketplaceItem?.item.owner ===
            userStore.user?.id && (
            <Popconfirm
              title="Are you sure you want to delete this item?"
              onConfirm={() =>
                handleDeleteItem(marketplaceStore.marketplaceItem?.item.id)
              }
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                shape="circle"
                style={{
                  border: "none",
                  padding: 0,
                  width: "auto",
                  height: "auto",
                  lineHeight: 0,
                }}
                icon={
                  <img
                    src={deleteImage}
                    alt="delete"
                    style={{
                      // width: "40px",
                      // height: "40px",
                      display: "block",
                    }}
                    className="flagSize"
                  />
                }
              />
            </Popconfirm>
          )}
          <Tooltip title={"Report"}>
            <Button
              type="primary"
              shape="circle"
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: 0,
                width: "auto",
                height: "auto",
                lineHeight: 0,
              }}
              onClick={() => requireAuth(() => setIsReportModalVisible(true))}
              icon={
                <img
                  src={flagImage}
                  alt="report"
                  style={{
                    // width: "40px",
                    // height: "40px",
                    display: "block",
                  }}
                  className="flagSize"
                />
              }
            />
          </Tooltip>
        </div>
      </Row>
      <ReportModal
        visible={isReportModalVisible}
        onClose={() => setIsReportModalVisible(false)}
        itemId={params.pk}
      />
      <Modal
        title="Submit Rating"
        open={showRatingModal}
        onOk={handleSubmitRating}
        onCancel={() => {
          setRating(initialRating);
          setShowRatingModal(false);
        }}
        okText="Submit"
        cancelText="Cancel"
      >
        Do you want to submit this rating?
      </Modal>
    </div>
  );
};

export default observer(ItemDetailsMedia);
